import SharedCarouselProducts from "./shared/carousel-products"
import Modal from "./components/modal";
import InputNumber from "./components/input-number"

export default class Cart {
    constructor(element) {
        this.cart = element

        this.shippingCalculatorButton = this.cart.querySelector('.cart-shipping-calculator-button')
        this.shippingCalculatorModalElement = this.cart.querySelector('#cart-shipping-calculator-modal')

        this.shippingMethodsField = this.cart.querySelector('.cart-shipping-methods')
        if (this.shippingMethodsField) {
            this.shippingMethodSecurity = this.shippingMethodsField.getAttribute('data-security')
            this.shippingMethods = this.shippingMethodsField.getElementsByTagName('input')

            for (let i = 0; i < this.shippingMethods.length; i++) {
                this.shippingMethods[i].addEventListener('click', (e) => {
                    this.handleShippingMethodsClick(this.shippingMethods[i])
                })
            }

            // Init modals
            this.shippingCalculatorModal = new Modal(this.shippingCalculatorModalElement)

            // Click shipping calculator button
            this.shippingCalculatorButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.shippingCalculatorModal.toggle();
            })
        }
    }

    handleShippingMethodsClick(element) {
        const shippingMethodName = element.getAttribute('name')
        const shippingMethodValue = element.value
        const url = "?wc-ajax=update_shipping_method"
        const request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                window.location.href = window.location.href;
                return false;
            } else {

            }
        };

        request.onerror = function () {
            // There was a connection error of some sort
        };

        request.send(`${shippingMethodName}=${shippingMethodValue}&security=${this.shippingMethodSecurity}`)
    }

}